import React, { useContext, useEffect, useRef, useState } from 'react'
import CardSection from '../../../../../../components/ui/card/CardSection'
import MolGrid, { Column } from '@moltech/molui/molgrid'
import { useDeletePendingContractAffiliateMutation, useLazyGetPendingContractAffiliatesQuery } from '../../../../../../app/services/pendingContractAPI';
import { PendingContractContext } from '../../../../../../utils/context/PendingContractContext';
import CustomCenterModel from '../../../../../../components/ui/customCenterModel/CustomCenterModel';
import { AppIcons } from '../../../../../../data/appIcons';
import Buttons from '../../../../../../components/ui/button/Buttons';
import AddPendingAffiliate from './features/AddPendingAffiliate';
import ToastService from '../../../../../../services/toastService/ToastService';
import SwalAlert from '../../../../../../services/swalService/SwalService';

const Affiliates = () => {
  const { pendingContractId } = useContext(PendingContractContext);
  const gridRef = useRef();
  const [gridData, setGridData] = useState([]);
  const [isModelOpen, setIsModelOpen] = useState(false);
  const { confirm } = SwalAlert();

  const [getPendingContractAffiliatesList, {
    isLoading: isAffiliatesListLoding,
    isSuccess: isAffiliatesListFetching,
    data: affiliatesListData
  }] = useLazyGetPendingContractAffiliatesQuery();

  const [deletePendingContractAffiliatesList, {
    isSuccess: isDeleteAffiliatesListFetching,
    data: deleteAffiliatesListData
  }] = useDeletePendingContractAffiliateMutation();


  const handleCloseModel = () => {
    setIsModelOpen(false);
  };

  const handleAddClick = () => {
    setIsModelOpen(true);
  };

  useEffect(() => {
    getList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pendingContractId])

  const getList = () => {
    getPendingContractAffiliatesList({ plPendingContractKey: pendingContractId });
  }

  useEffect(() => {
    if (!isAffiliatesListLoding && isAffiliatesListFetching && affiliatesListData) {
      setGridData(affiliatesListData);
    }
  }, [isAffiliatesListLoding, isAffiliatesListFetching, affiliatesListData])

  useEffect(() => {
    if (isDeleteAffiliatesListFetching && deleteAffiliatesListData) {
      if (deleteAffiliatesListData) {
        ToastService.success(deleteAffiliatesListData?.errorMessage);
        getList();
      }
      else {
        ToastService.error("Something went wrong");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDeleteAffiliatesListFetching, deleteAffiliatesListData, getPendingContractAffiliatesList]);

  const getCtxMenuItems = (row) => {
    if (!row) return [];
    return [
      {
        label: "Delete",
        command: () => {
          confirm("",
            "Are you sure you want to delete this Affiliate?",
            "Yes",
            "No"
          ).then((confirmed) => {
            if (confirmed) {
              if (row) {
                const request = {
                  plPendingContractKey: pendingContractId,
                  plDepartmentKey: row.lDepartmentKey
                }
                deletePendingContractAffiliatesList(request);
              }
            }
          });
        }
      }
    ];
  };

  const headerContent = () => {
    return (
      <div className="d-flex justify-content-end gap-3 export-icon">
        <Buttons
          buttonText="Add Affilliate"
          onClick={handleAddClick}
          buttonTypeClassName="btn blue-btn"
          titleText="Unassign Selected Items"
        />
      </div>
    );
  };

  return (
      <div className="row gap-4">
        <div className="scrollable-grid col-12">
          <CardSection
            cardTitle={`Affiliates`}
            customHeader={true}
            headerContent={headerContent()}
          >
            <MolGrid
              ref={gridRef}
              value={gridData}
              grouping
              expandableRowGroups={true}
              paginator={false}
              scrollable
              scrollHeight="flex"
              filterDisplay="row"
              sortMode="single"
              showGridlines
              resizableColumns
              ctxMenuItems={getCtxMenuItems}
            >
              <Column
                field="sClientName1"
                header="Client"
                grouping
                sortable
                style={{ width: "50%" }}
              />
              <Column
                field="sDepartmentName"
                header="Department"
                grouping
                sortable
                style={{ width: "50%" }}
              />

            </MolGrid>
          </CardSection>

          <CustomCenterModel
            isOpen={isModelOpen}
            useCustomBg={true}
            modalTitle={"Add Pending Contract Affilliate"}
            contentClass="content-30"
            onClose={handleCloseModel}
            modalTitleIcon={AppIcons.AddIcon}
            className="amendments-center-model"
          >
            <AddPendingAffiliate isOpen={isModelOpen} pendingContractId={pendingContractId} onClose={handleCloseModel} getList={getList} />
          </CustomCenterModel>
        </div>

      </div>
  )
}

export default Affiliates
